import React from "react";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./contact.css";
import DiscordWidget from "../components/DiscordWidget";

function Contact() {
  return (
    <div className="page-container contact-page">

      {/* =================================
          HERO
      ================================= */}

      <section className="contact-hero">
        <span className="contact-label">GET IN TOUCH</span>

        <h1>
          Contact <span>Vortex Network</span>
        </h1>

        <p>
          Have a question, suggestion, bug report, or just want to say hello?
          We'd love to hear from you.
        </p>
      </section>

      {/* =================================
          CONTACT OPTIONS
      ================================= */}

      <section className="contact-options">

        {/* Email */}

        <div className="contact-card">
          <div className="contact-icon">
            <i className="fa-solid fa-envelope"></i>
          </div>

          <h2>Email Support</h2>

          <p>
            Need help with an account, website issue, addon, or another
            Vortex Network service?
          </p>

          <a
            href="mailto:support@vortexnetowrknew.co.uk"
            className="contact-button"
          >
            <i className="fa-solid fa-paper-plane"></i>
            Email Us
          </a>

          <span className="contact-detail">
            support@vortexnetowrknew.co.uk
          </span>
        </div>

        {/* Discord */}

        <div className="contact-card">
          <div className="contact-icon discord-icon">
            <i className="fa-brands fa-discord"></i>
          </div>

          <h2>Discord Community</h2>

          <p>
            Join the Vortex Network community to chat with other players,
            get support, and stay up to date with our latest projects.
          </p>

          <a
            href="https://discord.com/invite/D8Z4HyRT6t "
            target="_blank"
            rel="noopener noreferrer"
            className="contact-button"
          >
            <i className="fa-brands fa-discord"></i>
            Join Discord
          </a>
        </div>

        {/* Social */}

        <div className="contact-card">
          <div className="contact-icon social-icon">
            <i className="fa-brands fa-x-twitter"></i>
          </div>

          <h2>Social Media</h2>

          <p>
            Follow us for announcements, updates, new projects, and other
            Vortex Network news.
          </p>

          <a
            href="https://twitter.com/k3chow1"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-button"
          >
            <i className="fa-brands fa-x-twitter"></i>
            Follow @k3chow1
          </a>
        </div>

      </section>

      {/* =================================
          DISCORD
      ================================= */}

      <section className="contact-discord">
        <div className="contact-section-header">
          <span className="contact-label">COMMUNITY</span>

          <h2>Join Our Discord</h2>

          <p>
            Connect with the Vortex Network community directly through
            Discord.
          </p>
        </div>

        <div className="discord-widget-wrapper">
          <DiscordWidget />
        </div>
      </section>

      {/* =================================
          SUPPORT
      ================================= */}

      <section className="contact-support">

        <div className="contact-support-icon">
          <i className="fa-solid fa-headset"></i>
        </div>

        <div>
          <span className="contact-label">NEED HELP?</span>

          <h2>Looking for Support?</h2>

          <p>
            Check out our support resources before contacting us. You may
            find the answer you're looking for in our FAQ or support pages.
          </p>

          <div className="contact-support-buttons">

            <Link to="/faq" className="support-button">
              <i className="fa-solid fa-circle-question"></i>
              FAQ
            </Link>

            <Link to="/support" className="support-button secondary">
              <i className="fa-solid fa-life-ring"></i>
              Support
            </Link>

          </div>
        </div>

      </section>

    </div>
  );
}

export default Contact;